import { Directive, ElementRef, OnInit, Input, Injector } from "@angular/core";
import { OverlayRef } from "@angular/cdk/overlay";
import { Observable } from "rxjs";
import { ComponentPortal, PortalInjector } from "@angular/cdk/portal";
import { DynamicOverlay } from "./dyanmic-overlay";
import { WorkingNotificationComponent } from "./working-notification.component";
import { WorkingNotificationData } from "./working-notification.config";

const defaultWorkingData: WorkingNotificationData = {
  title: "Working",
};

@Directive({
  selector: "[overlayWorking]",
})
export class OverlayWorkingDirective implements OnInit {
  @Input("overlayWorking") toggler: Observable<boolean>;
  @Input("fullscreenOverlay") fullScreen: boolean = false;
  @Input() workingData: WorkingNotificationData = defaultWorkingData;

  private overlayRef: OverlayRef;

  constructor(
    private host: ElementRef,
    private dynamicOverlay: DynamicOverlay,
    private parentInjector: Injector
  ) {}

  // TODO add another input to this directive to set a global container?
  // -- so i can have the container of my router-outlet also be the container for all my working notifications too?
  // -- this way it wont cover the nav bar, but it would still not go do the bottom so i dont know
  ngOnInit() {
    const container = this.fullScreen ? null : this.host.nativeElement;
    this.overlayRef = this.dynamicOverlay.createWithDefaultConfig(container);

    this.toggler.subscribe((show) => {
      if (show) {
        const injector = this.getInjector(
          this.workingData,
          this.parentInjector
        );
        const workerPortal = new ComponentPortal(
          WorkingNotificationComponent,
          null,
          injector
        );
        this.overlayRef.attach(workerPortal);
      } else {
        this.overlayRef.detach();
      }
    });
  }
  getInjector(
    data: WorkingNotificationData,
    parentInjector: Injector
  ): PortalInjector {
    const tokens = new WeakMap();

    tokens.set(WorkingNotificationData, data);
    return new PortalInjector(parentInjector, tokens);
  }
}
